import React, { useState } from "react";
// import { Row, Col, Button, Input, Form } from 'antd'
import { Button, Input, Radio, Form } from "antd";
// import { Row, Col, Button, Input, Select, Radio, Form } from 'antd'
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import provider from "providers/provider";
import { Loading, FallbackImage } from "components";
import formatDuration from "utils/formatDuration";
import { useHistory } from "react-router-dom";
import ls from "utils/secureLocalStorage";
import notFound from "layouts/moco/img/notfound.png";

// const { Option } = Select

const Search = (props) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const { onClickHandle, visible } = props;
  // const category = 'books'
  const [category, setCategory] = useState("books");
  // const [sort, setSort] = useState()
  const [loadingInput, setLoadingInput] = useState(false);
  // const [togleSearch, setTogleSearch] = useState(false)
  const [didDisplay, setDidDisplay] = useState(false);
  const [displayClearButton, setDisplayClearButton] = useState(false);
  const [empty, setEmpty] = useState(false);
  // const [colection, setColection] = useState()
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [lasQuery, setLashQuery] = useState("");

  const handleSearch = async (e) => {
    setLashQuery(category);
    setLoadingInput(true);
    setDisplayClearButton(true);
    switch (category) {
      case "books":
        await provider
          .singleWebHook(`webhook/search-book?q=${search}&limit=20`)
          .then((res) => {
            const { data, meta } = res;
            if (meta.total === 0) {
              setEmpty(true);
            } else {
              setEmpty(false);
            }

            setSearchResult(data);
            setLoadingInput(false);
            setDidDisplay(true);
          });
        break;
      case "video":
      case "audio":
        await provider
          .singleWebHook(
            `webhook/search-multimedia?q=${search}&type=${category}&limit=20`
          )
          .then((res) => {
            const { data, meta } = res;
            if (meta.total === 0) {
              setEmpty(true);
            } else {
              setEmpty(false);
            }

            setSearchResult(data);
            setLoadingInput(false);
            setDidDisplay(true);
          });
        break;
      case "article":
        await provider
          .singleWebHook(`webhook/news-list?q=${search}&limit=20`)
          .then((res) => {
            const { data, meta } = res;
            if (meta.total === 0) {
              setEmpty(true);
            } else {
              setEmpty(false);
            }

            setSearchResult(data);
            setLoadingInput(false);
            setDidDisplay(true);
          });
        break;

      default:
        break;
    }
  };

  const clearSearch = (e) => {
    setDidDisplay(false);
    setDisplayClearButton(false);
    form.resetFields();
  };

  const clickContent = (data) => {
    let keyName = "detail" + category;
    clearSearch();
    onClickHandle();
    return (
      ls.set(keyName, JSON.stringify(data)),
      history.push({
        pathname: `/content/${category}/detail-content/${data.id}`,
      })
    );
  };

  const displayResult = (item, i, type) => {
    switch (type) {
      case "books":
        return (
          <div
            className="search-bottomContent-right-item"
            onClick={() => clickContent(item)}
            style={{ cursor: "pointer" }}
            key={i}
          >
            <div className="search-bottomContent-right-item-coverBook">
              <FallbackImage src={item.cover_url} />
            </div>
            <div className="search-bottomContent-right-item-info">
              <div className="search-bottomContent-right-item-info-title">
                {item.book_title}
              </div>
              <div className="search-bottomContent-right-item-info-author">
                {item.author_name}
              </div>
            </div>
          </div>
        );
      case "audio":
      case "video":
        return (
          <div
            className="search-bottomContent-right-item"
            onClick={() => clickContent(item)}
            style={{ cursor: "pointer" }}
            key={i}
          >
            {type === "audio" && (
              <div className="search-bottomContent-right-item-coverAudio">
                <FallbackImage src={item.media_thumbnail_url} />
                <div className="duration">
                  {formatDuration(item.media_duration)}
                </div>
              </div>
            )}
            {type === "video" && (
              <div className="search-bottomContent-right-item-coverVideo">
                <FallbackImage src={item.media_thumbnail_url} />
                <div className="duration">
                  {formatDuration(item.media_duration)}
                </div>
              </div>
            )}

            <div className="search-bottomContent-right-item-info">
              <div className="search-bottomContent-right-item-info-title">
                {item.media_title}
              </div>
            </div>
          </div>
        );
      case "article":
        return (
          <div
            className="search-bottomContent-right-item"
            onClick={() => clickContent(item)}
            style={{ cursor: "pointer" }}
            key={i}
          >
            <div className="search-bottomContent-right-item-coverVideo">
              <FallbackImage src={item.news_thumbnail_url} />
            </div>

            <div className="search-bottomContent-right-item-info">
              <div className="search-bottomContent-right-item-info-title">
                <>{item.news_title}</>
                <br />
                <small>{item.news_author}</small>
              </div>
            </div>
          </div>
        );

      default:
        break;
    }
    if (type === "books") {
      return (
        <div
          className="search-bottomContent-right-item"
          onClick={() => clickContent(item)}
          style={{ cursor: "pointer" }}
          key={i}
        >
          <div className="search-bottomContent-right-item-coverBook">
            <FallbackImage src={item.cover_url} />
          </div>
          <div className="search-bottomContent-right-item-info">
            <div className="search-bottomContent-right-item-info-title">
              {item.book_title}
            </div>
            <div className="search-bottomContent-right-item-info-author">
              {item.author_name}
            </div>
          </div>
        </div>
      );
    } else if (type === "video" || type === "audio") {
      return (
        <div
          className="search-bottomContent-right-item"
          onClick={() => clickContent(item)}
          style={{ cursor: "pointer" }}
          key={i}
        >
          {type === "audio" && (
            <div className="search-bottomContent-right-item-coverAudio">
              <FallbackImage src={item.media_thumbnail_url} />
              <div className="duration">
                {formatDuration(item.media_duration)}
              </div>
            </div>
          )}
          {type === "video" && (
            <div className="search-bottomContent-right-item-coverVideo">
              <FallbackImage src={item.media_thumbnail_url} />
              <div className="duration">
                {formatDuration(item.media_duration)}
              </div>
            </div>
          )}

          <div className="search-bottomContent-right-item-info">
            <div className="search-bottomContent-right-item-info-title">
              {item.media_title}
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <div className="search" style={{ display: visible ? "" : "none" }}>
      <div className="search-topContent">
        <div className="search-topContent-back" onClick={() => onClickHandle()}>
          <ArrowLeftOutlined />
        </div>
        <div className="search-topContent-input">
          <Form form={form}>
            <Form.Item name="search">
              <Input
                size="large"
                className="search-input"
                placeholder="Pencarian..."
                onChange={(e) => setSearch(e.target.value)}
                onPressEnter={handleSearch}
                prefix={<SearchOutlined />}
              />
            </Form.Item>
          </Form>
        </div>
        <div className="search-topContent-clear">
          {displayClearButton && (
            <Button className="btn-clear" onClick={clearSearch}>
              Clear
            </Button>
          )}
        </div>
      </div>
      <div className="search-bottomContent">
        <div className="search-bottomContent-left">
          <Radio.Group
            onChange={(e) => {
              setCategory(e.target.value);
              if (lasQuery !== e.target.value) {
                setEmpty(false);
                clearSearch();
              }
            }}
            defaultValue="books"
            buttonStyle="solid"
          >
            <Radio.Button value="books">Buku</Radio.Button>
            <Radio.Button value="audio">Audio</Radio.Button>
            <Radio.Button value="video">Video</Radio.Button>
            <Radio.Button value="article">Artikel</Radio.Button>
          </Radio.Group>
        </div>
        <div className="search-bottomContent-right">
          {didDisplay &&
            (loadingInput ? (
              <Loading />
            ) : empty ? (
              <div className="no-result">
                <img src={notFound} alt="404" />
                Data tidak ditemukan
              </div>
            ) : (
              searchResult.map((item, i) => displayResult(item, i, category))
            ))}
        </div>
      </div>
    </div>
  );
};

export default Search;
